import React, { useEffect, useState } from "react";
import { Type, Save } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { api, formatApiError, BUTTON_DEFAULTS } from "@/lib/api";

const GROUPS = [
  ["reservas", "Reservaí"], ["dayuse", "DayUse"], ["bar", "Bar"], ["torneio", "Torneio"], ["instagram", "Instagram"], ["help", "Preciso de Ajuda"],
];

export default function ButtonTextsManager() {
  const [texts, setTexts] = useState({});
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/settings").then((r) => setTexts({ ...BUTTON_DEFAULTS, ...(r.data.button_texts || {}) })).catch(() => {});
  }, []);

  const save = async () => {
    setSaving(true);
    try { await api.post("/admin/settings/button-texts", { texts }); toast.success("Textos dos botões salvos!"); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setSaving(false); }
  };

  return (
    <div className="mb-8" data-testid="button-texts-manager">
      <div className="flex items-center gap-2">
        <Type className="h-5 w-5 text-[#1B7A45]" />
        <h2 className="font-display text-xl font-bold tracking-tight text-slate-900">Textos dos botões do menu</h2>
      </div>
      <p className="mt-1 text-sm text-slate-500">Título e subtítulo de cada botão. Deixe em branco para usar o texto padrão.</p>
      <div className="mt-3 space-y-2 rounded-2xl border border-slate-200 bg-white p-3">
        {GROUPS.map(([k, label]) => (
          <div key={k} className="grid grid-cols-1 gap-2 sm:grid-cols-[120px_1fr_1fr] sm:items-center">
            <span className="text-xs font-bold uppercase tracking-wider text-slate-500">{label}</span>
            <Input data-testid={`btntext-${k}-title`} placeholder={BUTTON_DEFAULTS[`${k}_title`]} value={texts[`${k}_title`] || ""} onChange={(e) => setTexts({ ...texts, [`${k}_title`]: e.target.value })} className="rounded-xl" />
            <Input data-testid={`btntext-${k}-sub`} placeholder={BUTTON_DEFAULTS[`${k}_sub`]} value={texts[`${k}_sub`] || ""} onChange={(e) => setTexts({ ...texts, [`${k}_sub`]: e.target.value })} className="rounded-xl" />
          </div>
        ))}
        <Button data-testid="btntext-save" onClick={save} disabled={saving} className="w-full rounded-xl bg-[#1B7A45] text-white hover:bg-[#156337]"><Save className="mr-1.5 h-4 w-4" /> {saving ? "Salvando..." : "Salvar textos"}</Button>
      </div>
    </div>
  );
}
